import { render, staticRenderFns } from "./AssetAllEditLog.vue?vue&type=template&id=38d0c685&scoped=true&"
import script from "./AssetAllEditLog.vue?vue&type=script&lang=js&"
export * from "./AssetAllEditLog.vue?vue&type=script&lang=js&"
import style0 from "./AssetAllEditLog.vue?vue&type=style&index=0&id=38d0c685&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d0c685",
  null
  
)

export default component.exports